import { render, staticRenderFns } from "./BaseRulesPanel.vue?vue&type=template&id=40c8401e"
import script from "./BaseRulesPanel.vue?vue&type=script&lang=js"
export * from "./BaseRulesPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseRulesPanel.vue?vue&type=style&index=0&id=40c8401e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports